import { render, staticRenderFns } from "./FooterCustom.vue?vue&type=template&id=ca55bfb0&scoped=true"
import script from "./FooterCustom.vue?vue&type=script&lang=js"
export * from "./FooterCustom.vue?vue&type=script&lang=js"
import style0 from "./FooterCustom.vue?vue&type=style&index=0&id=ca55bfb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca55bfb0",
  null
  
)

export default component.exports